import React from 'react'
import PropTypes from 'prop-types'
import Booking from './Booking'

const CalendarBookings = ({ bookings, doctors, handleBookingClick, locations, startOfDay }) => {
  if (!bookings) return null
  return (
    <div>
      {bookings.map(booking => (
        <Booking
          booking={booking}
          doctors={doctors}
          handleBookingClick={handleBookingClick}
          key={booking.id}
          locations={locations}
          topOffset={startOfDay - 1}
        />
      ))}
    </div>
  )
}

CalendarBookings.propTypes = {
  bookings: PropTypes.arrayOf(PropTypes.object),
  doctors: PropTypes.object,
  handleBookingClick: PropTypes.func.isRequired,
  locations: PropTypes.object,
  startOfDay: PropTypes.number.isRequired,
}

export default CalendarBookings



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/CalendarBookings.js